export default __webpack_public_path__ + "static/media/14.d435e9cc.jpg";